import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { CharacterClassifier } from '../core/characterClassifier.js';
export var WordCharacterClassifier = /*#__PURE__*/function (_CharacterClassifier) {
  _inherits(WordCharacterClassifier, _CharacterClassifier);

  var _super = _createSuper(WordCharacterClassifier);

  function WordCharacterClassifier(wordSeparators) {
    var _this;

    _classCallCheck(this, WordCharacterClassifier);

    _this = _super.call(this, 0
    /* Regular */
    );

    for (var i = 0, len = wordSeparators.length; i < len; i++) {
      _this.set(wordSeparators.charCodeAt(i), 2
      /* WordSeparator */
      );
    }

    _this.set(32
    /* Space */
    , 1
    /* Whitespace */
    );

    _this.set(9
    /* Tab */
    , 1
    /* Whitespace */
    );

    return _this;
  }

  return WordCharacterClassifier;
}(CharacterClassifier);

function once(computeFn) {
  var cache = {}; // TODO@Alex unbounded cache

  return function (input) {
    if (!cache.hasOwnProperty(input)) {
      cache[input] = computeFn(input);
    }

    return cache[input];
  };
}

export var getMapForWordSeparators = once(function (input) {
  return new WordCharacterClassifier(input);
});